// extracted by mini-css-extract-plugin
export default {"form":"Map-Team_form__oHKSs","formFooter":"Map-Team_formFooter__4ISqy"};